import { render } from "./index.mobile.vue?vue&type=template&id=070ac436&scoped=true&ts=true"
import script from "./index.mobile.vue?vue&type=script&scoped=true&lang=ts"
export * from "./index.mobile.vue?vue&type=script&scoped=true&lang=ts"

import "./index.mobile.vue?vue&type=style&index=0&id=070ac436&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-070ac436"]])

export default __exports__